// Microphone level for the voice input's meter: reads the recording stream
// through a Web Audio analyser and reports a 0..1 level about 16 times a second.
// Purely visual — without Web Audio (old browsers, tests) it reports nothing and
// the meter stays flat.
export class VoiceLevelMeter {
  constructor(stream, onLevel) {
    this.stream = stream
    this.onLevel = onLevel
  }

  start() {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext
    if (!AudioContextClass) return
    try {
      this.context = new AudioContextClass()
      const source = this.context.createMediaStreamSource(this.stream)
      this.analyser = this.context.createAnalyser()
      this.analyser.fftSize = 512
      source.connect(this.analyser)
    } catch {
      this.stop()
      return
    }
    const samples = new Uint8Array(this.analyser.fftSize)
    // setInterval, not requestAnimationFrame: a hidden tab stalls rAF and the
    // meter is the least important thing on the page.
    this.timer = setInterval(() => {
      this.analyser.getByteTimeDomainData(samples)
      let sum = 0
      samples.forEach((sample) => {
        const centered = (sample - 128) / 128
        sum += centered * centered
      })
      this.onLevel(Math.min(1, Math.sqrt(sum / samples.length) * 4))
    }, 60)
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
    this.context?.close?.()
    this.context = null
  }
}
